// Re-export AuthContext from shared package and configure it for Dining app
import type { ReactNode } from 'react';
import { AuthProvider as SharedAuthProvider, useAuth } from '@masonic-tools/shared-auth';
import { auth, db } from '@/lib/firebase';
import { showError, showSuccess } from '@/lib/swal';
import { Spinner } from '@/components/ui/spinner';

// Re-export the useAuth hook for backwards compatibility
export { useAuth } from '@masonic-tools/shared-auth';

function WaitForAuth({ children }: { children: ReactNode }) {
  const { loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background">
        <Spinner size="lg" />
      </div>
    );
  }
  return <>{children}</>;
}

// Create a configured AuthProvider for the Dining app
export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <SharedAuthProvider
      auth={auth}
      db={db}
      onSuccess={showSuccess}
      onError={showError}
    >
      <WaitForAuth>{children}</WaitForAuth>
    </SharedAuthProvider>
  );
}
